import React from 'react';
import Hero from './Hero';
import Footer from '../Company/About/Footer';
import Navbar from '../Company/About/Navbar';
import Content from './Content';
import { cn } from '@/lib/utils';

export default function CompanyAdmin() {
    return (
        <div className={cn("min-h-screen w-full bg-background flex flex-col")}>
            <Navbar />
            <Content />
            <Footer />
        </div>
    );
}